module.exports = __webpack_public_path__ + "img/biatic-colorido.8c1cbd85.png";